import { tns } from 'tiny-slider';

export default class ProductThumbsSlider {
    static sliders: any[] = [];

    static init() {
        const sliderContainers = document.querySelectorAll('.js-category-slider-init');

        sliderContainers.forEach((container: Element) => {
            // Zkontrolujeme, jestli už není inicializovaný
            if (container.classList.contains('tns-slider')) {
                return;
            }

            ProductThumbsSlider.initConnectedSliders(container);
        });
    }

    static destroy() {
        // Zničíme všechny existující slidery
        this.sliders.forEach((slider) => {
            if (slider && slider.destroy) {
                slider.destroy();
            }
        });
        this.sliders = [];
    }

    static initConnectedSliders(container: Element): void {
        const topSliderElement = container.querySelector(
            '.category-slider-top .category-slider-top__inner',
        ) as HTMLElement;
        const bottomSliderElement = container.querySelector(
            '.category-slider-bottom .category-slider-bottom__inner',
        ) as HTMLElement;

        if (!topSliderElement || !bottomSliderElement) {
            return;
        }

        // Inicializace horního (hlavního) slideru
        const topSlider = tns({
            loop: false,
            container: topSliderElement,
            items: 1,
            slideBy: 1,
            autoplay: false,
            controls: false,
            nav: false,
            mouseDrag: false,
            swipeAngle: false,
            mode: 'gallery',
            speed: 1000,
        });

        // Inicializace spodního (náhledového) slideru
        const bottomSlider = tns({
            loop: false,
            container: bottomSliderElement,
            items: 3,
            slideBy: 1,
            autoplay: false,
            controls: true,
            controlsContainer: container.querySelector('.category-slider-bottom__controls') as HTMLElement,
            nav: false,
            mouseDrag: true,
            swipeAngle: false,
            gutter: 7,
            responsive: {
                768: {
                    items: 4,
                },
                991: {
                    items: 5,
                },
            },
        });

        // Uložíme slidery pro možnost zničení
        this.sliders.push(topSlider, bottomSlider);

        // Propojení sliderů
        const bottomItems = bottomSliderElement.querySelectorAll('.category-slider-bottom__item');

        bottomItems.forEach((item: Element, index: number) => {
            item.addEventListener('click', () => {
                topSlider.goTo(index);
            });
        });

        topSlider.events.on('indexChanged', (info: any) => {
            const currentIndex = info.index;

            if (currentIndex < bottomItems.length) {
                bottomSlider.goTo(currentIndex);
            }
        });
    }
}